/*
We're constantly improving the code you see. 
Please share your feedback here: https://form.asana.com/?k=uvp-HPgd3_hyoXRBw1IcNg&d=1152665201300829
*/

import PropTypes from "prop-types";
import React from "react";
import "./style.css";

export const DefaultTrueFocus = ({
  className,
  text = "Label",
  divClassName,
  text1 = "Placeholder",
}) => {
  return (
    <div className={`default-true-focus ${className}`}>
      <div className="label" style={{ marginBottom: 8 }}>
        {text}
      </div>

      <div className="campo">
        <div className="content">
          <div
            className={`placeholder ${divClassName}`}
            style={{ marginTop: 8 }}
          >
            {text1}
          </div>
        </div>
      </div>
    </div>
  );
};

DefaultTrueFocus.propTypes = {
  text: PropTypes.string,
  text1: PropTypes.string,
};
